export default {
	sec_01: {
		title: {
			one: '고객님의 마음과',
			two: '소비자를 ',
			three: '위한 ',
			four: '것',
		},
		desc: {
			one: '기계 학습을 사용하여 비즈니스를 보호하고',
			two: '고객님의 자산과 소비자를 모두 보호 할 수 있습니다.',
		},
	},
	sec_14: {
		desc: {
			one: '귀하의 비즈니스에 고도로 맞춤화 가능한 상거래 솔루션이 필요하십니까?',
		},
		btn: '기업용 JPWORLDPAY에 대해 알아보기',
	},
	sec_03: {
		title: {
			one: '풍부한 경험',
		},
		desc: {
			one: '블록체인이 알려지기 시작부터 시작 된 블록체인 노하우를 바탕으로 만들어진',
			two: '자노페이를 통해 거래를 안전하게 사용해보시기 바랍니다.',
		},
		one: {
			title: {
				one: '안전하게 거래',
			},
			desc: {
				one: '세계에서 가장 안전한 블록체인을 토대로',
				two: '전 세계의 고객에게 다가갈 수 있습니다.',
			},
		},
		two: {
			title: {
				one: '사기 탐지 기술',
			},
			desc: {
				one: '당사의 사기 탐지 도구는 거래가 있을 때 마다 더욱 지능화되어',
				two: '기존 및 진화하는 위협으로부터 귀하를 보호합니다.',
			},
		},
	},
};
